import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button,
  TextField,
  Modal,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ipconfig from "../../../Core/ipconfig";
import axios from "axios";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddIcon from "@mui/icons-material/Add";
import { decryptData } from "../../../Core/util/obfuscate";

function Navbar({ onMenuClick }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [adminMe, setAdminMe] = useState<any>(null);

  React.useEffect(() => {
    const cached = localStorage.getItem("adminMe");
    if (cached) {
      setAdminMe(decryptData(cached));
    }
  }, [anchorEl]);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [adduserModal, setAdduserModal] = useState(false);
  const handleOpenAdduserModal = () => setAdduserModal(true);
  const handleCloseAdduserModal = () => setAdduserModal(false);

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/" || path === "/user") return "Users Directory";
    if (path === "/admin") return "Admin Accounts";
    if (path === "/appconfig") return "Global Configuration";
    if (path === "/companies") return "Companies Registry";
    if (path === "/enquiry") return "Client Enquiries";
    if (path === "/deletion-requests") return "Account Deletion Requests";
    if (path === "/partners") return "Partners Dashboard";
    if (path === "/logs") return "System Log Audit";
    if (path === "/subscriptions") return "Razorpay Transactions & Subscriptions";
    if (path === "/connections") return "Live Socket Diagnostics";
    return "Console Panel";
  };

  const addAdmin = async () => {
    let obj = {
      userName,
      email,
      phone,
      password,
    };
    try {
      const response = await axios.post(`${ipconfig}/adminpanel/create`, obj, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.status === 201) {
        handleCloseAdduserModal();
        setUserName("");
        setPassword("");
        setPhone("");
        setEmail("");
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("phone");
    localStorage.removeItem("adminMe");
    navigate("/login");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-popover" : undefined;

  return (
    <Box
      sx={{
        height: "70px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.palette.mode === "light" ? "#ffffff" : "#1e293b",
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingX: "24px",
        boxSizing: "border-box",
        flexShrink: 0,
      }}
    >
      {/* Left side: Hamburger on mobile + dynamic page title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {isMobile && (
          <IconButton onClick={onMenuClick} edge="start" color="inherit">
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            letterSpacing: "-0.5px",
          }}
        >
          {getPageTitle()}
        </Typography>
      </Box>

      {/* Right side: Action controls & user profile popover */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {/* <Tooltip title="Create New Administrator">
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleOpenAdduserModal}
            sx={{
              fontWeight: 600,
              fontSize: "13px",
              paddingY: "6px",
              paddingX: "14px",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Add Admin
          </Button>
        </Tooltip> */}

        <IconButton onClick={handleClick} sx={{ padding: "4px" }}>
          <AccountCircleIcon fontSize="large" sx={{ color: theme.palette.mode === "light" ? "#64748b" : "#94a3b8" }} />
        </IconButton>
      </Box>

      {/* Admin details Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            padding: "20px",
            width: "280px",
            boxShadow: theme.palette.mode === "light"
              ? "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
              : "0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)",
            borderRadius: "12px",
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, color: "text.primary" }}>
          Admin Profile
        </Typography>
        <Box sx={{ mb: 2, display: "flex", flexDirection: "column", gap: "6px" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Name: <strong>{adminMe?.name || adminMe?.userName || "N/A"}</strong>
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Phone: <strong>{adminMe?.phone ? `+91 ${adminMe.phone}` : "N/A"}</strong>
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Email: <strong>{adminMe?.email || "N/A"}</strong>
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Role: <strong>{adminMe?.isSuperAdmin || adminMe?.superAdmin ? "Super Admin" : "Admin"}</strong>
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Button
          variant="contained"
          color="error"
          fullWidth
          size="small"
          onClick={handleLogout}
          sx={{ fontWeight: 600 }}
        >
          Logout
        </Button>
      </Popover>

      {/* Add Admin Modal */}
      <Modal
        open={adduserModal}
        onClose={handleCloseAdduserModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            display: "flex",
            flexDirection: "column",
            borderRadius: "12px",
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, textAlign: "center", color: "text.primary" }}>
            Create New Admin
          </Typography>

          <TextField
            label="User Name"
            fullWidth
            margin="normal"
            size="small"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <TextField
            label="Password"
            fullWidth
            margin="normal"
            size="small"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            label="Phone"
            fullWidth
            margin="normal"
            size="small"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            size="small"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              mt: 3,
              gap: "12px",
            }}
          >
            <Button
              onClick={handleCloseAdduserModal}
              variant="outlined"
              fullWidth
              sx={{
                borderRadius: "8px",
                borderColor: theme.palette.mode === "light" ? "#fecaca" : "#7f1d1d",
                color: "error.main",
                "&:hover": {
                  backgroundColor: theme.palette.mode === "light" ? "#fef2f2" : "#450a0a",
                  borderColor: "error.main",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={addAdmin}
              variant="contained"
              fullWidth
              sx={{
                borderRadius: "8px",
                backgroundColor: "success.main",
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default Navbar;
